let Amenities = require('./amenities');
let AmenitiesMarker = require('./amenities-marker');

module.exports = {
  Amenities,
  AmenitiesMarker
};
